import React, { useState } from 'react'

import noxsys from './img/noxsys.png'
import d1 from './img/d1.png'
import d2 from './img/d2.png'
import d3 from './img/d3.png'
import d4 from './img/d4.png'
import d5 from './img/d5.png'
import d6 from './img/d6.png'
import g1 from './img/g1.png'
import g2 from './img/g2.png'
import info from './img/info.png'
import stageInfo from './img/stageInfo.png'
import menu from './img/menu.png'
import menuButton1 from './img/menuButton1.png'
import menuButton2 from './img/menuButton2.png'
import menuButton3 from './img/menuButton3.png'
import menuButton4 from './img/menuButton4.png'
import menuBar from './img/menuBar.png'
import menuBarButton1 from './img/menuBarButton1.png'
import menuBarButton2 from './img/menuBarButton2.png'
import menuBarButton3 from './img/menuBarButton3.png'
import logoNOXSYS from './img/logoNOXSYS.png'

import d1glass from './img/d1glass.png'
import g1glass from './img/g1glass.png'
import infoGlass from './img/infoGlass.png'
import stageInfoGlass from './img/stageInfoGlass.png'
import menuButtonGlass from './img/menuButtonGlass.png'
import menuBarGlass from './img/menuBarGlass.png'

const MainBanner: React.FC = () => {
    const [hoveredMenuBar, setHoveredMenuBar] = useState(false)
    const [hoveredMenu, setHoveredMenu] = useState(false)
    const [hoveredHeaderUp, setHoveredHeaderUp] = useState(false)
    const [hoveredHeaderDown, setHoveredHeaderDown] = useState(false)
    const [hoveredD1, setHoveredD1] = useState(false)
    const [hoveredD2, setHoveredD2] = useState(false)
    const [hoveredD3, setHoveredD3] = useState(false)
    const [hoveredD4, setHoveredD4] = useState(false)
    const [hoveredD5, setHoveredD5] = useState(false)
    const [hoveredD6, setHoveredD6] = useState(false)
    const [hoveredG1, setHoveredG1] = useState(false)
    const [hoveredG2, setHoveredG2] = useState(false)

    return (
        <div
            className={`flex w-[800px] h-fit items-start justify-start`}
            style={{ perspective: '400px' }}
        >
            <div
                className={`bg-[#181818] w-[810px] h-[670px] rounded-2xl shadow-2xl ring-[1px] ring-[#FFFFFF]`}
                style={{
                    transform: 'rotateY(-8deg) skewY(5deg)',
                    willChange: 'transform',
                    backfaceVisibility: 'hidden',
                }}
            >
                <div className={`flex h-full`}>
                    {/* Sidebar */}
                    <aside
                        className={`w-fit flex flex-row justify-start p-1 gap-1`}
                    >
                        <div
                            className={`relative flex flex-col w-14 justify-start text-[#FFFFFF] rounded rounded-tl-2xl rounded-bl-2xl gap-2 -translate-x-[30px] hover:-translate-x-[35px] duration-500 transform transition-all shadow-lg shadow-black/50 hover:scale-[1.03]`}
                            onMouseEnter={() => setHoveredMenuBar(true)}
                            onMouseLeave={() => setHoveredMenuBar(false)}
                        >
                            <img
                                src={menuBar}
                                alt="menuBar"
                                className={`absolute top-0 left-0 w-[155px] h-full`}
                            />
                            <img
                                src={logoNOXSYS}
                                alt="menuBarGlass"
                                className={`w-14 h-14 text-left rounded-[10px] -translate-x-[15px] hover:scale-110 duration-500 transform transition-all hover:-translate-x-[20px] hover:-translate-y-[5px]`}
                            />
                            <div
                                className={`relative flex w-[52px] h-[52px] items-center justify-center rounded-[10px] duration-500 transform transition-all z-10`}
                            >
                                <img
                                    src={menuBarButton1}
                                    alt="menuBarGlass"
                                    className={`absolute flex w-[41px] h-[41px] items-center justify-center font-bold text-left hover:-translate-x-[20px] z-30 duration-500 transform transition-all hover:scale-[1.15] ${hoveredMenuBar ? '-translate-x-[10px]' : '-translate-x-[0px]'}`}
                                />
                                <img
                                    src={menuBarGlass}
                                    alt="menuBarGlass"
                                    className={`absolute flex w-[52px] h-[52px] items-center justify-center rounded-[10px] duration-500 transform transition-all z-20 ${hoveredMenuBar ? '-translate-x-[10px] opacity-100' : ' opacity-0'}`}
                                />
                            </div>
                            <div
                                className={`relative flex w-[52px] h-[52px] items-center justify-center text-left`}
                            >
                                <img
                                    src={menuBarButton2}
                                    alt="menuBarGlass"
                                    className={`absolute flex w-[41px] h-[41px] items-center justify-center font-bold text-left hover:-translate-x-[20px] z-20 duration-500 transform transition-all hover:scale-[1.15] ${hoveredMenuBar ? '-translate-x-[10px]' : '-translate-x-[3px]'}`}
                                />
                                <img
                                    src={menuBarGlass}
                                    alt="menuBarGlass"
                                    className={`absolute flex w-[52px] h-[52px] items-center justify-center rounded-[10px] duration-500 transform transition-all z-10 ${hoveredMenuBar ? '-translate-x-[10px]' : ''}`}
                                />
                            </div>
                            <div
                                className={`relative flex w-[52px] h-[52px] items-center justify-center duration-500 transform transition-all`}
                            >
                                <img
                                    src={menuBarButton3}
                                    alt="menuBarGlass"
                                    className={`absolute flex w-[41px] h-[41px] items-center justify-center font-bold text-left hover:-translate-x-[20px] z-20 duration-500 transform transition-all hover:scale-[1.15] ${hoveredMenuBar ? '-translate-x-[10px]' : '-translate-x-[0px]'}`}
                                />
                                <img
                                    src={menuBarGlass}
                                    alt="menuBarGlass"
                                    className={`absolute flex w-[52px] h-[52px] items-center justify-center rounded-[10px] duration-500 transform transition-all z-10 ${hoveredMenuBar ? '-translate-x-[10px] opacity-100' : ' opacity-0'}`}
                                />
                            </div>
                        </div>
                        <div
                            className={`relative flex flex-col justify-start text-[#FFFFFF] rounded-[5px] -translate-x-[15px] hover:-translate-x-[20px] duration-500 transform transition-all shadow-lg shadow-black/65 hover:scale-[1.02]`}
                            onMouseEnter={() => setHoveredMenu(true)}
                            onMouseLeave={() => setHoveredMenu(false)}
                        >
                            <img
                                src={menu}
                                alt="Menu"
                                className={`absolute top-0 left-0 w-[155px] h-full opacity-50`}
                            />
                            <div
                                className={`flex items-center w-[155px] h-[60px] gap-1 py-2 pl-2 pt-8 text-[28px] font-extrabold rounded-[5px] z-10 duration-500 transform transition-all ${hoveredMenu ? '-translate-x-[15px] -translate-y-[13px] scale-[1.03] hover:scale-[1.05] hover:-translate-x-[18px]' : '-translate-x-[5px] -translate-y-[10px]'}`}
                            >
                                <img src={noxsys} alt="NOXSYS" />
                            </div>
                            <nav
                                className={`flex flex-col h-full space-y-2 grow`}
                            >
                                <div
                                    className={`relative flex items-center justify-center w-[155px] h-[45px]`}
                                >
                                    <div
                                        className={`absolute top-0 left-0 flex items-center justify-start w-[155px] h-[45px] text-left rounded-[5px] shadow-lg shadow-black/50 z-50 scale-[1.1] -translate-x-[25px] hover:scale-[1.15] hover:-translate-x-[30px] duration-500 transform transition-all`}
                                    >
                                        <img
                                            src={menuButton1}
                                            alt="menuButton1"
                                        />
                                    </div>
                                    <div
                                        className={`absolute top-0 left-0 flex items-center justify-center w-[155px] h-[45px] text-left rounded-[5px] shadow-lg shadow-black/50 opacity-50 -translate-x-[15px] z-20 scale-[1.05]`}
                                    >
                                        <img
                                            src={menuButtonGlass}
                                            alt="menuButtonGlass"
                                        />
                                    </div>
                                    <div
                                        className={`absolute top-0 left-0 flex items-center justify-center w-[155px] h-[45px] text-left rounded-[5px] shadow-lg shadow-black/50 opacity-40 -translate-x-[5px] z-10`}
                                    >
                                        <img
                                            src={menuButtonGlass}
                                            alt="menuButtonGlass"
                                        />
                                    </div>
                                </div>
                                <div
                                    className={`relative flex items-center justify-center w-[155px] h-[45px]`}
                                >
                                    <div
                                        className={`absolute top-0 left-0 flex items-center justify-start w-[155px] h-[45px] text-left rounded-[5px] z-50 duration-500 transform transition-all ${hoveredMenu ? '-translate-x-[25px] scale-[1.1] shadow-lg shadow-black/50 hover:-translate-x-[30px] hover:scale-[1.15]' : '-translate-x-[15px] scale-[1.05] shadow-lg shadow-black/50'}`}
                                    >
                                        <img
                                            src={menuButton2}
                                            alt="menuButton2"
                                        />
                                    </div>
                                    <div
                                        className={`absolute top-0 left-0 flex items-center justify-center w-[155px] h-[45px] text-left rounded-[5px] z-20 duration-500 transform transition-all ${hoveredMenu ? '-translate-x-[15px] scale-[1.05] opacity-50 shadow-lg shadow-black/50' : '-translate-x-[5px] opacity-40 shadow-lg shadow-black/50'}`}
                                    >
                                        <img
                                            src={menuButtonGlass}
                                            alt="menuButtonGlass"
                                        />
                                    </div>
                                    <div
                                        className={`absolute top-0 left-0 flex items-center justify-center w-[155px] h-[45px] text-left rounded-[5px] z-10 duration-500 transform transition-all -translate-x-[5px] ${hoveredMenu ? 'opacity-40' : 'opacity-0'}`}
                                    >
                                        <img
                                            src={menuButtonGlass}
                                            alt="menuButtonGlass"
                                        />
                                    </div>
                                </div>
                                <div
                                    className={`relative flex items-center justify-center w-[155px] h-[45px]`}
                                >
                                    <div
                                        className={`absolute top-0 left-0 flex items-center justify-start w-[155px] h-[45px] text-left rounded-[5px] z-50 duration-500 transform transition-all ${hoveredMenu ? '-translate-x-[25px] scale-[1.1] shadow-lg shadow-black/30 hover:-translate-x-[30px] hover:scale-[1.15]' : '-translate-x-[10px] scale-[1.05] shadow-lg shadow-black/30'}`}
                                    >
                                        <img
                                            src={menuButton3}
                                            alt="menuButton3"
                                        />
                                    </div>
                                    <div
                                        className={`absolute top-0 left-0 flex items-center justify-center w-[155px] h-[45px] text-left rounded-[5px] z-20 duration-500 transform transition-all ${hoveredMenu ? '-translate-x-[15px] scale-[1.05] opacity-50 shadow-lg shadow-black/30' : 'opacity-0 shadow-lg shadow-black/30'}`}
                                    >
                                        <img
                                            src={menuButtonGlass}
                                            alt="menuButtonGlass"
                                        />
                                    </div>
                                    <div
                                        className={`absolute top-0 left-0 flex items-center justify-center w-[155px] h-[45px] text-left rounded-[5px] z-10 duration-500 transform transition-all ${hoveredMenu ? '-translate-x-[5px] opacity-40' : 'opacity-0'}`}
                                    >
                                        <img
                                            src={menuButtonGlass}
                                            alt="menuButtonGlass"
                                        />
                                    </div>
                                </div>
                            </nav>
                            <div
                                className={`w-[155px] h-[45px] text-left rounded-[5px] -translate-x-[10px] shadow-lg shadow-black/45 duration-500 transform transition-all ${hoveredMenu ? '-translate-x-[13px] shadow-black/65 scale-[1.05] hover:-translate-x-[20px] hover:scale-[1.1]' : ''}`}
                            >
                                <img src={menuButton4} alt="menuButton4" />
                            </div>
                        </div>
                    </aside>

                    {/* Main Panel */}
                    <div
                        className={`flex flex-col items-start justify-start p-1 w-[700px] text-[#FFFFFF] space-y-2 rounded-tr-2xl rounded-br-2xl`}
                    >
                        {/* Header Up */}
                        <div
                            className={`relative flex items-center justify-center w-[560px] h-[100px]`}
                            onMouseEnter={() => setHoveredHeaderUp(true)}
                            onMouseLeave={() => setHoveredHeaderUp(false)}
                        >
                            <div
                                className={`absolute flex flex-1 top-[24px] left-[10px] w-7 h-7 rounded-full bg-[#4e9bff96] z-[54] duration-500 transform transition-all ${hoveredHeaderUp ? '-translate-x-[30px] -translate-y-[8px] shadow-lg shadow-black/50' : 'shadow-lg shadow-black/50'}`}
                            ></div>
                            <div
                                className={`absolute flex flex-1 top-[30px] left-[15px] w-4 h-4 rounded-full bg-[#4e9aff] z-[55] duration-500 transform transition-all hover:scale-110 hover:-translate-x-[35px] ${hoveredHeaderUp ? '-translate-x-[32px] -translate-y-[9px] shadow-lg shadow-black/50' : 'shadow-lg shadow-black/50'}`}
                            ></div>
                            <div
                                className={`absolute flex flex-1 top-[24px] left-[170px] w-7 h-7 rounded-full bg-[#563af596] z-[54] duration-500 transform transition-all ${hoveredHeaderUp ? '-translate-x-[30px] -translate-y-[8px] shadow-lg shadow-black/50' : 'shadow-lg shadow-black/50'}`}
                            ></div>
                            <div
                                className={`absolute flex flex-1 top-[30px] left-[175px] w-4 h-4 rounded-full bg-[#563af5] z-[55] duration-500 transform transition-all hover:scale-110 hover:-translate-x-[35px] ${hoveredHeaderUp ? '-translate-x-[32px] -translate-y-[9px] shadow-lg shadow-black/50' : 'shadow-lg shadow-black/50'}`}
                            ></div>
                            <div
                                className={`absolute flex flex-1 top-[24px] left-[330px] w-7 h-7 rounded-full bg-[#3c18bc96] z-[54] duration-500 transform transition-all ${hoveredHeaderUp ? '-translate-x-[30px] -translate-y-[8px] shadow-lg shadow-black/50' : 'shadow-lg shadow-black/50'}`}
                            ></div>
                            <div
                                className={`absolute flex flex-1 top-[30px] left-[335px] w-4 h-4 rounded-full bg-[#3c18bc] z-[55] duration-500 transform transition-all hover:scale-110 hover:-translate-x-[35px] ${hoveredHeaderUp ? '-translate-x-[32px] -translate-y-[9px] shadow-lg shadow-black/50' : 'shadow-lg shadow-black/50'}`}
                            ></div>
                            <div
                                className={`absolute flex flex-1 top-[24px] left-[490px] w-7 h-7 rounded-full bg-[#27259396] z-[54] duration-500 transform transition-all ${hoveredHeaderUp ? '-translate-x-[30px] -translate-y-[8px] shadow-lg shadow-black/50' : 'shadow-lg shadow-black/50'}`}
                            ></div>
                            <div
                                className={`absolute flex flex-1 top-[30px] left-[495px] w-4 h-4 rounded-full bg-[#272593] z-[55] duration-500 transform transition-all hover:scale-110 hover:-translate-x-[35px] ${hoveredHeaderUp ? '-translate-x-[32px] -translate-y-[9px] shadow-lg shadow-black/50' : 'shadow-lg shadow-black/50'}`}
                            ></div>
                            <div
                                className={`absolute top-0 left-0 flex w-[560px] h-[100px] justify-start items-start rounded rounded-tr-2xl z-20 duration-500 transform transition-all ${hoveredHeaderUp ? '-translate-x-[30px] -translate-y-[18px] scale-[1.07] shadow-lg shadow-black/50' : 'shadow-lg shadow-black/50 scale-[1.05] -translate-x-[10px] -translate-y-[12px]'}`}
                            >
                                <img src={stageInfo} alt="stageInfo" />
                            </div>
                            <div
                                className={`absolute top-0 left-0 flex w-[560px] h-[100px] items-center justify-center text-left rounded-[5px] rounded-tr-2xl z-10 -translate-y-[10px] duration-500 transform transition-all ${hoveredHeaderUp ? 'translate-x-[0px] -translate-y-[15px] shadow-lg shadow-black/50' : 'translate-x-[10px] -translate-y-[10px] shadow-lg shadow-black/50'}`}
                            >
                                <img
                                    src={stageInfoGlass}
                                    alt="stageInfoGlass"
                                />
                            </div>
                            <div
                                className={`absolute top-0 left-0 flex w-[560px] h-[100px] items-center justify-center text-left rounded-[5px] rounded-tr-2xl z-10 -translate-y-[10px] duration-500 transform transition-all ${hoveredHeaderUp ? 'translate-x-[25px] -translate-y-[12px] scale-[0.95]' : 'translate-x-[30px] -translate-y-[10px] scale-[0.95]'}`}
                            >
                                <img
                                    src={stageInfoGlass}
                                    alt="stageInfoGlass"
                                />
                            </div>
                        </div>

                        {/* Header Down */}
                        <div
                            className={`relative flex items-center justify-center w-[560px] h-[60px]`}
                            onMouseEnter={() => setHoveredHeaderDown(true)}
                            onMouseLeave={() => setHoveredHeaderDown(false)}
                        >
                            <div
                                className={`absolute top-0 left-0 flex w-[560px] h-[60px] justify-start items-start rounded-[5px] z-30 duration-500 transform transition-all ${hoveredHeaderDown ? '-translate-x-[30px] scale-[1.1] -translate-y-[6px] shadow-lg shadow-black/50' : '-translate-x-[10px] -translate-y-[5px] scale-[1.05] shadow-lg shadow-black/50'}`}
                            >
                                <img src={info} alt="Info" />
                            </div>
                            <div
                                className={`absolute top-0 left-0 flex w-[560px] h-[60px] items-center justify-center text-left rounded-[5px] z-20 duration-500 transform transition-all ${hoveredHeaderDown ? ' scale-[1.03] -translate-x-[5px] -translate-y-[5px] shadow-lg shadow-black/50' : 'translate-x-[10px] -translate-y-[4px] shadow-lg shadow-black/50 scale-[1]'}`}
                            >
                                <img src={infoGlass} alt="InfoGlass" />
                            </div>
                            <div
                                className={`absolute top-0 left-0 flex w-[560px] h-[60px] items-center justify-center text-left rounded-[5px] z-10 duration-500 transform transition-all ${hoveredHeaderDown ? 'translate-x-[25px] -translate-y-[5px] shadow-lg shadow-black/50 scale-[0.95]' : 'translate-x-[35px] -translate-y-[3px] shadow-lg shadow-black/50 scale-[0.93]'}`}
                            >
                                <img src={infoGlass} alt="InfoGlass" />
                            </div>
                        </div>

                        {/* Diag Grid (placeholders for now) */}
                        <div className={`flex flex-row gap-1 w-[560px]`}>
                            <div
                                className={`relative flex flex-1 h-32 mt-2`}
                                onMouseEnter={() => setHoveredD1(true)}
                                onMouseLeave={() => setHoveredD1(false)}
                            >
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded z-50 duration-500 transform transition-all hover:bg-[#464447] ${hoveredD1 ? '-translate-x-[38px] scale-[1.07] z-[51] shadow-lg shadow-black/50' : '-translate-x-[10px] scale-[0.95] shadow-lg shadow-black/50'}`}
                                >
                                    <img src={d1} alt="Diag1" />
                                </div>
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded z-40 duration-500 transform transition-all ${hoveredD1 ? '-translate-x-[23px] scale-[1] shadow-lg shadow-black/50' : '-translate-x-[10px] scale-[0.95] shadow-lg shadow-black/50'}`}
                                >
                                    <img src={d1glass} alt="Glass" />
                                </div>
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded z-30 duration-500 transform transition-all ${hoveredD1 ? '-translate-x-[10px] scale-[0.95]' : '-translate-x-[10px]   scale-[0.95]'} `}
                                >
                                    <img src={d1glass} alt="Glass" />
                                </div>
                            </div>
                            <div
                                className={`relative flex flex-1 h-32 mt-2`}
                                onMouseEnter={() => setHoveredD2(true)}
                                onMouseLeave={() => setHoveredD2(false)}
                            >
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded duration-500 transform transition-all ${hoveredD2 ? '-translate-x-[27px] scale-[1.07] shadow-lg shadow-black/50 z-[52]' : '-translate-x-[14px] scale-[1.0] z-50 shadow-lg shadow-black/50'}`}
                                >
                                    <img src={d2} alt="Diag2" />
                                </div>
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded z-40 duration-500 transform transition-all ${hoveredD2 ? '-translate-x-[14px] scale-[1.0] shadow-lg shadow-black/50' : '-translate-x-[2px] scale-[0.95] shadow-lg shadow-black/50'}`}
                                >
                                    <img src={d1glass} alt="Glass" />
                                </div>
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded  z-30 duration-500 transform transition-all ${hoveredD2 ? '-translate-x-[2px] scale-[0.95] opacity-100' : '-translate-x-[2px] scale-[0.95] opacity-0'} `}
                                >
                                    <img src={d1glass} alt="Glass" />
                                </div>
                            </div>
                            <div
                                className={`relative flex flex-1 h-32 mt-2`}
                                onMouseEnter={() => setHoveredD3(true)}
                                onMouseLeave={() => setHoveredD3(false)}
                            >
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded  duration-500 transform transition-all hover:bg-[#464447] ${hoveredD3 ? '-translate-x-[8px] scale-[1.1] shadow-lg shadow-black/50 z-[53]' : '-translate-x-[0px] scale-[1.05] z-[51] shadow-lg shadow-black/50'}`}
                                >
                                    <img src={d3} alt="Diag3" />
                                </div>
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded z-40 duration-500 transform transition-all ${hoveredD3 ? 'translate-x-[5px] scale-[1.05] shadow-lg shadow-black/50' : 'scale-[1] translate-x-[13px] shadow-lg shadow-black/50'}`}
                                >
                                    <img src={d1glass} alt="Glass" />
                                </div>
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded z-30 duration-500 transform transition-all ${hoveredD3 ? 'translate-x-[21px] scale-[0.95]' : 'translate-x-[23px] scale-[0.95]'} `}
                                >
                                    <img src={d1glass} alt="Glass" />
                                </div>
                            </div>
                        </div>

                        <div className={`flex flex-row gap-1 w-[560px]`}>
                            <div
                                className={`relative flex flex-1 h-32 mt-2`}
                                onMouseEnter={() => setHoveredD4(true)}
                                onMouseLeave={() => setHoveredD4(false)}
                            >
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded z-50 duration-500 transform transition-all hover:bg-[#464447] ${hoveredD4 ? '-translate-x-[38px] translate-y-[5px] scale-[1.07] z-[51] shadow-lg shadow-black/50' : '-translate-x-[10px] scale-[0.95] shadow-lg shadow-black/50'}`}
                                >
                                    <img src={d4} alt="Diag4" />
                                </div>
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded z-40 duration-500 transform transition-all ${hoveredD4 ? '-translate-x-[23px] translate-y-[2px] scale-[1] shadow-lg shadow-black/50' : '-translate-x-[10px] scale-[0.95] shadow-lg shadow-black/50'}`}
                                >
                                    <img src={d1glass} alt="Glass" />
                                </div>
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded z-30 duration-500 transform transition-all ${hoveredD4 ? '-translate-x-[10px] scale-[0.95]' : '-translate-x-[10px] scale-[0.95]'} `}
                                >
                                    <img src={d1glass} alt="Glass" />
                                </div>
                            </div>
                            <div
                                className={`relative flex flex-1 h-32 mt-2`}
                                onMouseEnter={() => setHoveredD5(true)}
                                onMouseLeave={() => setHoveredD5(false)}
                            >
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded duration-500 transform transition-all ${hoveredD5 ? '-translate-x-[27px] scale-[1.07] shadow-lg shadow-black/50 z-[52]' : '-translate-x-[14px] scale-[1.0] z-50 shadow-lg shadow-black/50'}`}
                                >
                                    <img src={d5} alt="Diag5" />
                                </div>
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded z-40 duration-500 transform transition-all ${hoveredD5 ? '-translate-x-[14px] scale-[1.0] shadow-lg shadow-black/50' : '-translate-x-[2px] scale-[0.95] shadow-lg shadow-black/50'}`}
                                >
                                    <img src={d1glass} alt="Glass" />
                                </div>
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded  z-30 duration-500 transform transition-all ${hoveredD5 ? '-translate-x-[2px] scale-[0.95] opacity-100' : '-translate-x-[2px] scale-[0.95] opacity-0'} `}
                                >
                                    <img src={d1glass} alt="Glass" />
                                </div>
                            </div>
                            <div
                                className={`relative flex flex-1 h-32 mt-2`}
                                onMouseEnter={() => setHoveredD6(true)}
                                onMouseLeave={() => setHoveredD6(false)}
                            >
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded  duration-500 transform transition-all hover:bg-[#464447] ${hoveredD6 ? '-translate-x-[8px] scale-[1.1] shadow-lg shadow-black/50 z-[53]' : '-translate-x-[0px] scale-[1.05] z-[51] shadow-lg shadow-black/50'}`}
                                >
                                    <img src={d6} alt="Diag3" />
                                </div>
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded z-40 duration-500 transform transition-all ${hoveredD6 ? 'translate-x-[5px] scale-[1.05] shadow-lg shadow-black/50' : 'scale-[1] translate-x-[13px] shadow-lg shadow-black/50'}`}
                                >
                                    <img src={d1glass} alt="Glass" />
                                </div>
                                <div
                                    className={`absolute flex flex-1 top-0 left-0 w-full h-32 rounded z-30 duration-500 transform transition-all ${hoveredD6 ? 'translate-x-[21px] scale-[0.95]' : 'translate-x-[23px] scale-[0.95]'} `}
                                >
                                    <img src={d1glass} alt="Glass" />
                                </div>
                            </div>
                        </div>

                        {/* Graphs section (placeholders) */}
                        <div className={`flex flex-row gap-1 w-[565px]`}>
                            <div
                                className={`relative flex flex-1 h-44 translate-y-[15px] -mt-1`}
                                onMouseEnter={() => setHoveredG1(true)}
                                onMouseLeave={() => setHoveredG1(false)}
                            >
                                <div
                                    className={`absolute top-0 left-0 flex flex-1 bg-[#262427] w-full h-44 rounded duration-500 transform transition-all ${hoveredG1 ? '-translate-x-[30px] translate-y-[8px] shadow-lg shadow-black/65 scale-[1.07] z-[52]' : '-translate-x-[15px] translate-y-[4px] z-[49] scale-[1] shadow-lg shadow-black/65'}`}
                                >
                                    <img src={g1} alt="Graph1" />
                                </div>
                                <div
                                    className={`absolute top-0 left-0 flex flex-1 w-full h-44 rounded duration-500 transform transition-all z-40 ${hoveredG1 ? '-translate-x-[15px] translate-y-[4px] shadow-lg shadow-black/65 scale-[1]' : '-translate-x-[2px] scale-[0.95]'}`}
                                >
                                    <img src={g1glass} alt="Glass" />
                                </div>
                                <div
                                    className={`absolute top-0 left-0 flex flex-1 w-full h-44 rounded duration-500 transform transition-all -translate-x-[2px] scale-[0.95] z-30 ${hoveredG1 ? 'opacity-100' : 'opacity-0'}`}
                                >
                                    <img src={g1glass} alt="Glass" />
                                </div>
                            </div>
                            <div
                                className={`relative flex flex-1 h-44 translate-y-[15px] -mt-1`}
                                onMouseEnter={() => setHoveredG2(true)}
                                onMouseLeave={() => setHoveredG2(false)}
                            >
                                <div
                                    className={`absolute top-0 left-0 flex flex-1 w-full h-44 rounded duration-500 transform transition-all ${hoveredG2 ? '-translate-x-[15px] translate-y-[8px] shadow-lg shadow-black/50 scale-[1.07] z-[55]' : '-translate-x-[8px] translate-y-[8px] z-[49] scale-[1.05] shadow-lg shadow-black/65'}`}
                                >
                                    <img src={g2} alt="Graph2" />
                                </div>
                                <div
                                    className={`absolute top-0 left-0 flex flex-1 w-full h-44 rounded duration-500 transform transition-all ${hoveredG2 ? 'translate-x-[2px] translate-y-[4px] shadow-lg shadow-black/65 z-40 scale-[1.02]' : 'translate-x-[7px] translate-y-[4px] scale-[1] z-40 shadow-lg shadow-black/50'}`}
                                >
                                    <img src={g1glass} alt="Glass" />
                                </div>
                                <div
                                    className={`absolute top-0 left-0 flex flex-1 w-full h-44 rounded duration-500 transform transition-all z-30 ${hoveredG2 ? 'translate-x-[18px] scale-[0.95]' : 'translate-x-[20px] scale-[0.95]'}`}
                                >
                                    <img src={g1glass} alt="Glass" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MainBanner
